import React from 'react';
import ReactDOM from 'react-dom/client';
import { CaApp } from './ca/ui/CaApp';
// Zelf-gehoste fonts (offline): Cinzel (titels), EB Garamond (verhaal), JetBrains Mono (cijfers).
import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';
import '@fontsource/eb-garamond/400.css';
import '@fontsource/eb-garamond/400-italic.css';
import '@fontsource/eb-garamond/500.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/700.css';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <CaApp />
  </React.StrictMode>
);
